// extracted by mini-css-extract-plugin
export default {"root":"InfoCard_root__ZiHFp"};